import { type EmojiProvider } from '@atlaskit/emoji/resource';

export enum ReactionStatus {
	ready = 'READY',
	loading = 'LOADING',
	error = 'ERROR',
	notLoaded = 'NOT_LOADED',
	disabled = 'DISABLED',
}

export type ReactionSummary = {
	ari: string;
	containerAri: string;
	emojiId: string;
	count: number;
	reacted: boolean;
};

export type ReactionsProps = {
	cloudId: string;
	contentId: string;
	containerId: string;
	containerType: string;
	emojiProvider: Promise<EmojiProvider>;
	handleMarkAsRead: () => void;
	experienceTrackingAttributes: ExperienceTrackingAttributes;
};

export type ExperienceTrackingAttributes = Record<string, string | number>;
